import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/admin/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/events",
    name: "Events",
    component: () => import("../views/Events.vue"),
    props: { title: "events" }
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
    props: { title: "news" }
  },
  {
    path: "/services",
    name: "Services",
    component: () => import("../views/Service.vue"),
    props: { title: "services" }
  },
  {
    path: "/businesses",
    name: "Businesses",
    component: () => import("../views/Business.vue"),
    props: { title: "businesses" }
  },
  {
    path: "/councillors",
    name: "Councillors",
    component: () => import("../views/Councillors.vue"),
    props: { title: "councillors", display: "Councillors & Staff" }
  },
  {
    path: "/agm",
    name: "AGM",
    component: () => import("../views/Agm.vue"),
    props: { title: "agm" }
  },
  {
    path: "/bylaws",
    name: "Bylaw",
    component: () => import("../views/Bylaw.vue"),
    props: { title: "bylaws" }
  },
  {
    path: "/galleries",
    name: "Gallery",
    component: () => import("../views/Gallery.vue"),
    props: { title: "Galleries" }
  },
  {
    path: "/unsubscribe/:email",
    name: "Unsubscribe",
    component: () => import("../views/Unsubscribe.vue")
  },
  // ADMIN ROUTES
  {
    path: "/admin/homepage",
    name: "HomePage",
    component: () => import(/* webpackChunkName: "Form" */ "../views/admin/HomePage.vue")
  },
  {
    path: "/admin/form/:title/:type/:id?",
    name: "Form",
    component: () =>
      import(/* webpackChunkName: "Form" */ "../views/admin/Form.vue")
  },
  {
    path: "/admin/dashboard/:page?",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "Dash" */ "../views/admin/Dashboard.vue")
  },
  {
    path: "/admin/settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "Settings" */ "../views/admin/Settings.vue")
  },
  {
    path: "/admin",
    name: "Login",
    component: Login
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
